import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectFinalFormsUnsavedValues = state => state.finalFormsUnsavedValues;
const selectNamespace = (state, props) => props.namespace;

const makeSelectFinalFormUnsavedValues = () =>
    createDeepEqualSelector(
        [selectFinalFormsUnsavedValues, selectNamespace],
        (finalFormsUnsavedValuesState, namespaceProp) =>
            finalFormsUnsavedValuesState[namespaceProp]
    );

const makeSelectFinalFormUnsavedValuesExist = () =>
    createDeepEqualSelector(
        [selectFinalFormsUnsavedValues, selectNamespace],
        (finalFormsUnsavedValuesState, namespaceProp) =>
            !!finalFormsUnsavedValuesState[namespaceProp]
    );

export {
    selectFinalFormsUnsavedValues,
    makeSelectFinalFormUnsavedValues,
    makeSelectFinalFormUnsavedValuesExist
};
